
import React from 'react';
const zip = (...rows) => [...rows[0]].map((_,c) => rows.map(row => row[c]));
function importAll(r){
    let modules = r.keys().map(r);
    let orig_module_names = zip(r.keys(), modules);
    let result = {}
    for(let i in orig_module_names){
        result[orig_module_names[i][0]] = orig_module_names[i][1];
    }
    return result;
}
const imagePaths = {
    'multiplayer_card_images': importAll(require.context(`../../static/assets/multiplayer_card_images/`, false, /\.(png|jpe?g|svg)$/)),
    'game_icons': importAll(require.context(`../../static/assets/game_icons/`, false, /\.(png|jpe?g|svg)$/)),
    'images': importAll(require.context(`../../images/`, false, /\.(png|jpe?g|svg)$/)),
    'quick-play-icons': importAll(require.context(`../../static/assets/quick-play-icons`, false, /\.(png|jpe?g|svg)$/)),
    'position_icons': importAll(require.context(`../../static/assets/position_icons/`, false, /\.(png|jpe?g|svg)$/)),
    'business_group_logos': importAll(require.context(`../../static/assets/business_group_logos/`, false, /\.(png|jpe?g|svg)$/))
}
console.log(imagePaths)
export function withStaticImages(assetFolder, WrappedComponent){
    return class extends React.Component{
        getImage(sourceName){
            let imageName = sourceName.replace("'", "");
            let image = imagePaths[assetFolder][`./${imageName}`];
            if(typeof image === 'undefined' || image === null ){
                console.log(`   ~~~ withStaticImage(${assetFolder}, ${sourceName}) was not found`);
                console.log(imagePaths)
                image = imagePaths['images'][`./default.png`];
            }
            return image.startsWith('data:image')?image:`../../..${image}`;            
        }

        render(){
            return(<WrappedComponent {...this.props} getImage={(sourceName)=>this.getImage(sourceName)}/>);
        }
    }
}

export default withStaticImages;


// WEBPACK FOOTER //
// ./src/services/utils/imageNameRetriever.js